<template>
	<div>
        <apexchart type=line height=400 :options="chartOptions" :series="series"></apexchart>
    </div>
</template>

<script>
import apexchart from 'vue-apexcharts'
import { dateTimeIsoToLocal } from '@/filters/utils'

export default {
    components: {
        apexchart
    },
    data: function() {
        var context = this
        context.listaGasMaxima = []
        context.listaGasMinima = []
        context.listaMedicoes = []
        context.values.forEach(function(item) {
            context.listaGasMaxima.push(item.gMax)
            context.listaGasMinima.push(item.gMin)
            context.listaMedicoes.push(item.data)
        })
        context.seriesMontada = [
            {
                name: 'Concentração Gás Máxima',
                type: 'line',
                data: context.listaGasMaxima
            },
            {
                name: 'Concentração Gás Minima',
                type: 'line',
                data: context.listaGasMinima
            },
        ]
        return {
            listaGasMinima: [],
            listaGasMaxima: [],
            listaMedicoes: [],
            seriesMontada: [],
            chartOptions: {
                colors: ['#10303D', '#ff5429'],
                stroke: {
                    curve: 'straight',
                    dashArray: [0, 0],
                    width: [2, 2],
                    colors: ['#10303D', '#ff5429'],
                },
                markers: {
                    size: [6, 6]
                },
                xaxis: {
                    type: 'datetime',
                    categories: context.listaMedicoes,
                    title: {
                        text: 'Data/Hora de Medição',
                    },
                    labels: {
						style: {
							colors: '#000000de'
						},
                        formatter: function (val) {
							if (context._data.chartOptions.xaxis.categories.length > 0)
                            {
                                return context.dateTimeIsoToLocal(new Date(val).toISOString().replace('T', ' ').replace('Z', '')).substring(0, 16)
                            }
                            else
                            {
                                return ''
                            }
						}
					}
                },
                yaxis: {
                    labels: {
						style: {
							color: '#000000de'
						},
						formatter: function (val) {
							return val + ' ppm'
						}
					}
                },
                legend: {
                    position: 'top',
                    horizontalAlign: 'center',
                    fontSize: '14px',
                    labels: {
                        useSeriesColors: false
                    },
                },
            },
            series: this.seriesMontada
        }
    },
    props: {
        values: Array
    },
    methods: {
        dateTimeIsoToLocal,
    }
}

</script>
        